// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DislikeOutlinedSvg from "@ant-design/icons-svg/es/asn/DislikeOutlined";
import AntdIcon from '../components/AntdIcon';

var DislikeOutlined = function DislikeOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: DislikeOutlinedSvg
  }));
};

DislikeOutlined.displayName = 'DislikeOutlined';
export default React.forwardRef(DislikeOutlined);